// src/components/settings/DistributorRowActionMenu.jsx

import React from "react";
import "../../assets/styles/common.css";
import "./Settings.css"; // Keep this for specific settings tab styles

const DistributorRowActionMenu = ({
  distributor, // Changed prop name
  openMenuId,
  actionMenuRefs,
  toggleRowActions,
  handleEditDistributor, // Changed prop name
  handleDeleteDistributor, // Changed prop name
  setOpenMenuId, // Pass this to close menu after action
}) => {
  const isOpen = openMenuId === distributor.id;

  // Add ref to the specific menu for click outside detection
  const setRef = (el) => {
    if (el) {
      actionMenuRefs.current[distributor.id] = el;
    } else {
      delete actionMenuRefs.current[distributor.id];
    }
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    handleEditDistributor(distributor);
    setOpenMenuId(null); // Close menu after action
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    handleDeleteDistributor(distributor.id);
    // Menu will be closed by handleDeleteDistributor's finally block
  };

  return (
    <td
      className={`table-actions-cell ${isOpen ? "is-menu-active" : ""}`}
      onClick={(e) => e.stopPropagation()} // Prevent row click from closing other menus
    >
      <div className="row-actions-wrapper">
        <button
          className="ellipsis-button"
          onClick={(e) => toggleRowActions(distributor.id, e)}
          data-distributor-id={distributor.id} // Add data attribute for click outside logic
        >
          &#x22EE; {/* Vertical Ellipsis character */}
        </button>
        <div
          ref={setRef}
          className={`row-action-menu ${isOpen ? "is-open" : ""}`}
        >
          <button onClick={handleEditClick} className="action-menu-item">
            Edit
          </button>
          <button
            onClick={handleDeleteClick}
            className="action-menu-item delete-item"
          >
            Delete
          </button>
        </div>
      </div>
    </td>
  );
};

export default DistributorRowActionMenu;
